import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import SwitchField from 'components/new_ui/Form/SwitchField';

import { Formik, Form as FormikForm } from 'formik';

export default function Slots({
  selectedDay, monthTimeSlots, selectedTime, setSelectedTime,
}) {
  return (
    <div className="choose-time-slots-mode mt-2">
      <Formik initialValues={{ timeSlotsMode: false }}>
        {({ values }) => (
          <>
            <FormikForm className="needs-validation" noValidate="">
              <SwitchField
                id="time-slots-mode"
                name="timeSlotsMode"
                uncheckedLabel="AM/PM"
                checkedLabel="24 hours"
              />
            </FormikForm>

            { (!selectedDay || !monthTimeSlots
                    || !monthTimeSlots.slots[selectedDay] || monthTimeSlots.slots[selectedDay].length === 0) && (
                      <div style={{ height: '250px' }}>
                        Unfortunately, there are no time slots available for this date.
                        Please select a different date.
                      </div>
            )}

            {selectedDay && monthTimeSlots && monthTimeSlots.slots[selectedDay]
                    && monthTimeSlots.slots[selectedDay].length > 0 && (
                      <div
                        style={{
                          height: '250px', overflowY: 'scroll', padding: '20px', scrollbarColor: 'auto',
                        }}
                      >
                        {monthTimeSlots.slots[selectedDay] && monthTimeSlots.slots[selectedDay].map((timeSlot) => {
                          const slotDate = timeSlot.start;

                          return (
                            <Button
                              key={timeSlot.start}
                              variant={null}
                              className={
                                `time-slot px-2 border rounded text-nowrap w-100 mb-3
                                ${selectedTime && selectedTime === slotDate ? 'active' : ''}
                                `
                              }
                              onClick={(e) => {
                                const buttons = e.target.parentElement.parentElement.querySelectorAll('button');
                                buttons.forEach((button) => button.classList.remove('active'));

                                e.target.classList.add('active');
                                setSelectedTime(slotDate);
                              }}
                            >
                              {values.timeSlotsMode ? timeSlot.hours_24 : timeSlot.hours}
                            </Button>
                          );
                        })}
                      </div>
            )}
          </>
        )}
      </Formik>
    </div>
  );
}

Slots.propTypes = {
  selectedDay: PropTypes.instanceOf(Date),
  monthTimeSlots: PropTypes.object.isRequired,
  selectedTime: PropTypes.instanceOf(Date),
  setSelectedTime: PropTypes.func,
};

Slots.defaultProps = {
  selectedDay: null,
  selectedTime: null,
  setSelectedTime: () => {},
};
